import { Toasts } from '../components/toaster/Toast'

// Returns false if the input is not numeric. This will throw a Toasts error as well.
export const isValidNumericInput = (
    value: string,
    allowDecimals: boolean = true,
    allowNegative: boolean = false,
): boolean => {
    if (value.length === 0) {
        return true
    }

    // If the user enters a dot as the first character, prepend a zero
    if (allowDecimals && value.charAt(0) == '.' && value.length == 1) {
        value = '0' + value
    }

    if (isValidNumber(value, allowNegative)) {
        if (value.includes('.') && !allowDecimals) {
            Toasts.error('Only whole numbers are allowed!')
            return false
        }

        return true
    } else {
        let error = 'Only numeric values are allowed.'
        if (allowDecimals) {
            error += ' Please use "." (dot) as decimal delimiter'
        }

        Toasts.error(error)
        return false
    }
}

// allow only floats and integers
const isValidNumber = (number: string, allowNegative: boolean): boolean => {
    // regexr.com/86sds
    let regex
    if (allowNegative) {
        regex = /^(\-?(0|[1-9]\d*|0\d*)(\.\d*)?|\-?\.\d+|-)$/
    } else {
        regex = /^((0|[1-9]\d*|0\d*)(\.\d*)?|\.\d+|-)$/
    }

    return regex.test(number)
}

const isDecimalField = (fieldName: string): boolean => {
    const decimalFields = ['bid_increase_amount', 'bid_increase_percent']

    return decimalFields.includes(fieldName)
}
